module.exports = __webpack_public_path__ + "static/media/vail-17.4f8f9ac9.jpg";